document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!isOpen));
      mobileMenu.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });
  }

  document.querySelectorAll('[data-quantity]').forEach((wrapper) => {
    const input = wrapper.querySelector('input[type="number"]');
    wrapper.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = Number(button.dataset.step);
        const current = Number(input.value || 1);
        const minimum = Number(input.min || 1);
        input.value = Math.max(minimum, current + direction);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-slideshow]').forEach((slideshow) => {
    const slides = Array.from(slideshow.querySelectorAll('[data-slide]'));
    const buttons = Array.from(slideshow.querySelectorAll('[data-slide-button]'));
    const prevButton = slideshow.querySelector('[data-slide-prev]');
    const nextButton = slideshow.querySelector('[data-slide-next]');
    const interval = Number(slideshow.dataset.interval || 6000);
    let activeIndex = 0;
    let timer;

    if (slides.length < 2) return;

    const showSlide = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => slide.classList.toggle('is-active', index === activeIndex));
      buttons.forEach((button, index) => button.classList.toggle('is-active', index === activeIndex));
    };

    const start = () => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      window.clearInterval(timer);
      timer = window.setInterval(() => showSlide(activeIndex + 1), interval);
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        showSlide(Number(button.dataset.slideButton));
        start();
      });
    });
    if (prevButton) prevButton.addEventListener('click', () => { showSlide(activeIndex - 1); start(); });
    if (nextButton) nextButton.addEventListener('click', () => { showSlide(activeIndex + 1); start(); });

    slideshow.addEventListener('mouseenter', () => window.clearInterval(timer));
    slideshow.addEventListener('mouseleave', start);
    start();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantSelect = form.querySelector('[data-variant-select]');
    const price = form.closest('.product-info')?.querySelector('[data-product-price]');
    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.options[variantSelect.selectedIndex];
        if (price && option?.dataset.price) price.textContent = option.dataset.price;
      });
    }
  });

  document.querySelectorAll('[data-live-activity]').forEach(async (section) => {
    const endpoint = section.dataset.endpoint;
    const stat = section.querySelector('[data-live-activity-stat]');
    const number = section.querySelector('[data-live-viewers]');
    if (!endpoint || !stat || !number) return;
    const load = async () => {
      try {
        const response = await fetch(endpoint, { cache: 'no-store' });
        if (!response.ok) return;
        const data = await response.json();
        const viewers = Number(data.viewers);
        if (!Number.isFinite(viewers) || viewers < 0) return;
        number.textContent = String(Math.round(viewers));
        stat.hidden = false;
      } catch (_) {}
    };
    await load();
    window.setInterval(load, 60000);
  });

  document.querySelectorAll('[data-recent-purchases]').forEach((wrap) => {
    const items = Array.from(wrap.querySelectorAll('[data-recent-purchase]'));
    if (!items.length) return;
    const delay = Number(wrap.dataset.delay || 20000);
    const duration = Number(wrap.dataset.duration || 7000);
    let index = 0;
    let closed = false;
    const showNext = () => {
      if (closed) return;
      items.forEach((item) => item.hidden = true);
      const item = items[index % items.length];
      item.hidden = false;
      item.classList.add('is-visible');
      window.setTimeout(() => {
        item.classList.remove('is-visible');
        item.hidden = true;
        index += 1;
        window.setTimeout(showNext, delay);
      }, duration);
    };
    wrap.querySelectorAll('[data-recent-close]').forEach((button) => button.addEventListener('click', () => {
      closed = true;
      items.forEach((item) => item.hidden = true);
    }));
    window.setTimeout(showNext, Math.min(delay, 8000));
  });
});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-collection-filters]').forEach((form) => {
    form.querySelectorAll('[data-filter-checkbox]').forEach((input) => {
      input.addEventListener('change', () => form.requestSubmit());
    });
  });
});


// TSV CLEAN v14: remove any stale/injected product-page "Ready for Signed Jersey" option.
(() => {
  const removeSignedToggle = () => {
    document.querySelectorAll('.product-info').forEach((productInfo) => {
      productInfo.querySelectorAll('.signed-ready-option, [data-signed-request], [data-ready-for-signed-jersey]').forEach((el) => el.remove());
      productInfo.querySelectorAll('input[name="properties[Ready for Signed Jersey]"], [data-signed-ready]').forEach((el) => {
        const wrapper = el.closest('.signed-ready-option, .product-form__field, label, div');
        if (wrapper && /Ready for Signed Jersey/i.test(wrapper.textContent || '')) wrapper.remove();
        else el.remove();
      });
      productInfo.querySelectorAll('form[data-product-form] > *, .product-form > *').forEach((el) => {
        const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (/Ready for Signed Jersey/i.test(text) && /authenticated signed version|saved with the cart item/i.test(text)) {
          el.remove();
        }
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', removeSignedToggle, { once: true });
  else removeSignedToggle();

  const observer = new MutationObserver(removeSignedToggle);
  const startObserver = () => {
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  else startObserver();
})();
